import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white pt-24 md:pt-40 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 bg-gradient-to-r from-amber-400 to-amber-600 bg-clip-text text-transparent">
          Privacy Policy
        </h1>
        
        <div className="space-y-8 text-gray-300">
          <div>
            <p className="text-sm text-gray-400 mb-6">Last updated: {new Date().toLocaleDateString()}</p>
            
            <p className="mb-4">
              At Visual Creationz, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Information We Collect</h2>
            <p className="mb-4">We collect information that you provide directly to us, including:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Name, email address, and phone number</li>
              <li>Photos, videos, and other media you upload</li>
              <li>Payment information (processed securely through Stripe)</li>
              <li>Communication preferences and special requests</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">How We Use Your Information</h2>
            <p className="mb-4">We use the information we collect to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Create your custom memory film or video</li>
              <li>Process payments and send receipts</li>
              <li>Communicate with you about your order</li>
              <li>Improve our services and customer experience</li>
              <li>Send marketing communications (with your consent)</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Data Security</h2>
            <p className="mb-4">
              We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. Payment information is processed through Stripe's secure payment gateway.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Your Media Files</h2>
            <p className="mb-4">
              Photos and videos you upload are used solely for creating your memory film. We store your files securely and do not share them with third parties. Upon completion of your project, files are retained for 30 days for revision purposes, then securely deleted unless you request otherwise.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Your Rights</h2>
            <p className="mb-4">You have the right to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Access your personal information</li>
              <li>Request corrections to your data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Cookies</h2>
            <p className="mb-4">
              We use cookies and similar tracking technologies to improve your browsing experience and analyze website traffic. You can control cookie preferences through your browser settings.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Third-Party Services</h2>
            <p className="mb-4">
              We use third-party services including Stripe (payment processing) and Google Analytics (website analytics). These services have their own privacy policies governing the use of your information.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Changes to This Policy</h2>
            <p className="mb-4">
              We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on this page and updating the "Last updated" date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-4">Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this Privacy Policy or how we handle your data, please contact us:
            </p>
            <ul className="space-y-2">
              <li>Business: Simon Balfour trading as Visual Creationz</li>
              <li>Email: visualcreationz@hotmail.com</li>
              <li>Phone: 07494 164379</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
